import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=6ffcda8d"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=6ffcda8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports